import { Allotment } from '@linktivity/gds-neo';
import { message } from '@linktivity/link-ui';
import { auth } from '@link/supplier/stores';

const BASE_PATH = import.meta.env.VITE_APP_SUPPLIER_LEGACY_API as string;

const config = new Allotment.Configuration({
  basePath: BASE_PATH,
  middleware: [
    {
      pre: async context => {
        const requestHeaders: HeadersInit = new Headers({
          'Content-Type': 'application/json'
        });
        requestHeaders.append(
          'Authorization',
          'Bearer ' + (await auth.getRefreshedToken())
        );
        context.init.headers = requestHeaders;
      },
      post: async context => {
        if (context.response.status === 401) {
          localStorage.clear();
          location.replace('/login');
        } else if (!context.response.ok) {
          // handle error
          const data = await context.response.json();
          message.error(
            data.common.error_description || data.common.error_code,
            10
          );
        }
      }
    }
  ]
});

const allotmentApi = new Allotment.AllotmentApi(config);

export default allotmentApi;
